import { render, staticRenderFns } from "./IdentificationKeys.vue?vue&type=template&id=9e7d515a&"
import script from "./IdentificationKeys.vue?vue&type=script&lang=js&"
export * from "./IdentificationKeys.vue?vue&type=script&lang=js&"
import style0 from "./IdentificationKeys.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports